/* import __COLOCATED_TEMPLATE__ from './example-question-suggestions-list.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { answerListAcceptRejectTransition } from 'embercom/transition-maps/answers-transitions';

export default class ExampleQuestionSuggestionList extends Component {
  transition = answerListAcceptRejectTransition;
}
